import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Visibility, Add, Map } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll, wsUpdate } from 'services/WService.js';

//modal
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import ModalNewZone from './ModalNewZone';
import ButtonDelete from 'hooks/ButtonDelete';
import { Box, Switch } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  size: {
    fontSize: '4.4rem',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '# Acciones', accessor: 'num', excelEnabled: false },
  { Header: 'Polígono', accessor: 'polygon' },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Zona', accessor: 'name' },
  { Header: 'Nombre almacén', accessor: 'warehouse' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'GPS falso choferes', accessor: 'falseGps', excelEnabled: false, width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false },
];

export default WithApp(function Zone(props) {
  const [notify, showNotify] = useToasty();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openNewZone, setOpenNewZone] = useState(false); //cambiar a false
  const [zone, setZone] = useState({});
  const [layers, setLayers] = useState({});

  const [zones, setZones] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  async function loadZones() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    setDataLoading(false);
    if (response.success) setZones(response.data);
  }

  async function listLayers() {
    setDataLoading(true);
    let response = await wsGetAll('base/layer');
    setDataLoading(false);
    if (response.success) setLayers(response.data);
  }

  //marca por GPS falso a todos los choferes de la zona; los vendedores no se tocan
  async function aplicarValidacion(zone, activo) {
    setZones((previas) =>
      previas.map((item) =>
        item.id === zone.id ? { ...item, false_gps: activo ? item.choferes_movil : 0 } : item,
      ),
    );

    let response = await wsUpdate(`base/zone/${zone.id}/validations`, {
      false_gps: activo ? 1 : 0,
    });
    if (response.success) showNotify(response.message);
    else showNotify(response.message, 'error');

    loadZones();
  }

  //el switch va prendido solo si TODOS los choferes de la zona están marcados
  function switchValidacion(zone) {
    const total = zone.choferes_movil || 0;
    return (
      <Switch
        checked={total > 0 && zone.false_gps === total}
        disabled={total === 0}
        onChange={(e) => aplicarValidacion(zone, e.target.checked)}
        color="secondary"
      />
    );
  }

  useEffect(() => {
    loadZones();
    listLayers();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal
        open={open}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadZones}
        zoneId={zone.id}
        layers={layers}
      />

      <ModalNewZone
        open={openNewZone}
        setOpen={setOpenNewZone}
        zone={zone}
        setZone={setZone}
        reload={loadZones}
        showNotify={showNotify}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_ZONES_STORE}
              component={
                <CardIcon color="primary">
                  <Map style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                color="success"
                onClick={() => {
                  setOpenNewZone(true);
                }}
                pointer="true"
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Zonas{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Zonas"
              defaultWidth={1000}
              indexRow={[0, 1, 2, 5, 6, 7]}
              widthRow={[160, 100, 100, 120, 150, 10]}
              columns={columns}
              data={zones.map((zone, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <Box display="flex" alignItems="center">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_SHOW}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => {
                            setOpen(true);
                            setZone(zone);
                          }}
                          className="like"
                        >
                          <Visibility />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => {
                            setOpenNewZone(true);
                            setZone(zone);
                          }}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_ZONES_DELETED}>
                        <ButtonDelete entity="base/zone" id={zone.id} reload={loadZones} />
                      </AllowedGuard>
                    </Box>
                  ),
                  polygon: zone.geometry !== null ? 'Si' : 'No',
                  code: zone.code,
                  name: zone.description,
                  warehouse: zone.WhsName,
                  state: zone.state === 'A' ? 'Activo' : 'Inactivo',
                  falseGps: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(zone)}
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
